import { render, staticRenderFns } from "./PlatonFieldset.vue?vue&type=template&id=0df7c09e"
import script from "./PlatonFieldset.vue?vue&type=script&lang=js"
export * from "./PlatonFieldset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports